import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { AppMainComponent } from 'src/app/app.main.component';
import { LoginService } from 'src/app/login/login.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit {

    constructor(public app: AppComponent, public appMain: AppMainComponent, public loginService: LoginService)

    {}

  ngOnInit(): void {
  }

  notify(){
    $.notify('testing', { position: "top left", className: 'error' });
  }

}
